var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3484",
    "data-name": "Group 3484",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.806,
    height: 24.759,
    viewBox: "0 0 26.806 24.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cart",
    "data-name": "Icon ionic-ios-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M12.657,29.672a1.547,1.547,0,1,1-1.547-1.547A1.547,1.547,0,0,1,12.657,29.672Z",
    transform: "translate(-3.896 -6.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M28.442,29.672a1.547,1.547,0,1,1-1.547-1.547,1.547,1.547,0,0,1,1.547,1.547Z",
    transform: "translate(-5.21 -6.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M30.178,8.9a.379.379,0,0,0-.335-.271L8.848,6.594a.646.646,0,0,1-.483-.3,6.564,6.564,0,0,0-.786-1.2c-.5-.606-1.431-.587-3.146-.6A.939.939,0,0,0,3.382,5.4a.921.921,0,0,0,1.006.909,8.565,8.565,0,0,1,1.676.122c.3.09.548.587.638,1.018a.024.024,0,0,0,.006.019c.013.077.129.658.129.664l2.578,13.64a5.013,5.013,0,0,0,.935,2.3,2.572,2.572,0,0,0,2.121,1.044H27.722a.916.916,0,0,0,.928-.864.9.9,0,0,0-.9-.941H12.458a.749.749,0,0,1-.535-.18,2.893,2.893,0,0,1-.741-1.676L10.9,19.931a.035.035,0,0,1,.026-.039l17.9-3.03a.377.377,0,0,0,.316-.335l1.031-7.465A.368.368,0,0,0,30.178,8.9Z",
    transform: "translate(-3.382 -4.493)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.255509198ec2085d972982d8008375c2.svg";
export { ForwardRef as ReactComponent };